import { endpoints, request } from '!core/api';

export const walletServices = {
  accountPortfolio: ({ account }) =>
    request.get(
      endpoints.backoffice(`WsbGetPortfolioValue?account=${account}`),
    ),
};
